import React, {
    useEffect,
    useState,
} from "react";

import {
    Link,
    useLocation,
} from "react-router-dom";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

const AlumniComment = () => {

    const [
        comments,
        setComments,
    ] = useState([]);

    const [open, setOpen] =
        useState(false);

    const location =
        useLocation();

    useEffect(() => {

        fetchComments();

    }, []);

    const fetchComments =
        async () => {

            try {

                const res =
                    await fetch(
                        "https://stjosephweb.ilakshyaerp.in/api/alumni-comment/approved"
                    );

                const result =
                    await res.json();

                if (
                    result.success
                ) {

                    setComments(
                        result.comments
                    );

                }

            } catch {

                console.log(
                    "Failed to load comments"
                );

            }
        };

    return (

        <>

            {/* HEADER */}
            <Header
                toggleSidebar={() =>
                    setOpen(true)
                }
            />

            {/* SIDEBAR */}
            <Sidebar
                isOpen={open}
                close={() =>
                    setOpen(false)
                }
            />

            {/* PAGE */}
            <div className="w-full min-h-screen bg-[#f4f6fb]">

                {/* TOP MENU */}
                <div className="bg-[#d89f12] shadow-md">

                    <div className="max-w-7xl mx-auto">

                        <div className="flex flex-wrap justify-center">

                            {/* REGISTRATION */}
                            <Link
                                to="/alumni"
                                className={`
                                px-8
                                py-4
                                text-white
                                font-semibold
                                border-r
                                border-white/40
                                transition-all
                                duration-300

                                ${
                                    location.pathname ===
                                    "/alumni"
                                        ? "bg-[#072F5F]"
                                        : "hover:bg-[#072F5F]"
                                }
                              `}
                            >
                                Alumni Registration
                            </Link>

                            {/* LOGIN */}
                            <Link
                                to="/alumni-login"
                                className={`
                                px-8
                                py-4
                                text-white
                                font-semibold
                                border-r
                                border-white/40
                                transition-all
                                duration-300

                                ${
                                    location.pathname ===
                                    "/alumni-login"
                                        ? "bg-[#072F5F]"
                                        : "hover:bg-[#072F5F]"
                                }
                              `}
                            >
                                Alumni Login
                            </Link>

                            {/* COMMENT */}
                            <Link
                                to="/alumni-comments"
                                className={`
                                px-8
                                py-4
                                text-white
                                font-semibold
                                transition-all
                                duration-300

                                ${
                                    location.pathname ===
                                    "/alumni-comments"
                                        ? "bg-[#072F5F]"
                                        : "hover:bg-[#072F5F]"
                                }
                              `}
                            >
                                Alumni Comment
                            </Link>

                        </div>

                    </div>

                </div>

                {/* MAIN */}
                <div className="max-w-6xl mx-auto px-4 py-16">

                    {/* HEADER CARD */}
                    <div
                        className="
                        bg-gradient-to-r
                        from-[#072F5F]
                        to-[#0c4d99]
                        rounded-t-[30px]
                        px-10
                        py-10
                        shadow-xl
                      "
                    >

                        <h1
                            className="
                            text-5xl
                            md:text-6xl
                            font-bold
                            text-white
                            text-center
                          "
                        >

                            Alumni Comments

                        </h1>

                        <p
                            className="
                            text-center
                            text-white/80
                            mt-4
                            text-lg
                          "
                        >

                            Experiences and feedback from our alumni students

                        </p>

                    </div>

                    {/* COMMENT BOX */}
                    <div
                        className="
                        bg-white
                        rounded-b-[30px]
                        shadow-2xl
                        overflow-hidden
                        border
                        border-gray-200
                      "
                    >

                        {
                            comments.length === 0 && (

                                <div className="py-24 text-center text-gray-500 text-xl">

                                    No Comments Available

                                </div>
                            )
                        }

                        {
                            comments.map(
                                (
                                    item,
                                    index
                                ) => (

                                    <div
                                        key={
                                            item.id
                                        }
                                        className={`
                                        px-6
                                        md:px-12
                                        py-10
                                        transition-all
                                        duration-300
                                        hover:bg-[#f9fbff]

                                        ${
                                            index !==
                                            comments.length - 1
                                                ? "border-b border-dashed border-gray-300"
                                                : ""
                                        }
                                      `}
                                    >

                                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 items-center">

                                            {/* LEFT */}
                                            <div className="lg:col-span-2">

                                                <div className="relative">

                                                    {/* QUOTE */}
                                                    <div
                                                        className="
                                                        absolute
                                                        -top-6
                                                        -left-2
                                                        text-[70px]
                                                        text-[#d89f12]/20
                                                        font-bold
                                                      "
                                                    >
                                                        “

                                                    </div>

                                                    <p
                                                        className="
                                                        text-[18px]
                                                        leading-10
                                                        text-gray-700
                                                        relative
                                                        z-10
                                                      "
                                                    >

                                                        {
                                                            item.commentText
                                                        }

                                                    </p>

                                                </div>

                                            </div>

                                            {/* RIGHT */}
                                            <div
                                                className="
                                                flex
                                                items-center
                                                gap-5
                                                bg-[#f8fbff]
                                                rounded-2xl
                                                p-5
                                                border
                                                border-[#dbe8ff]
                                              "
                                            >

                                                {/* IMAGE */}
                                                <img
                                                    src={`https://stjosephweb.ilakshyaerp.in/uploads/alumni/${item.image}`}
                                                    alt=""
                                                    className="
                                                    w-24
                                                    h-24
                                                    rounded-full
                                                    object-cover
                                                    border-4
                                                    border-[#d89f12]
                                                    shadow-md
                                                  "
                                                />

                                                {/* INFO */}
                                                <div>

                                                    <h2
                                                        className="
                                                        text-xl
                                                        font-bold
                                                        text-[#072F5F]
                                                        mb-3
                                                      "
                                                    >

                                                        {
                                                            item.fullName
                                                        }

                                                    </h2>

                                                    <p className="text-gray-600 text-sm mb-2">

                                                        <span className="font-semibold text-[#072F5F]">

                                                            Class :

                                                        </span>

                                                        {" "}

                                                        {
                                                            item.className
                                                        }
                                                        -
                                                        {
                                                            item.sectionName
                                                        }

                                                    </p>

                                                    <p className="text-gray-600 text-sm">

                                                        <span className="font-semibold text-[#072F5F]">

                                                            Session :

                                                        </span>

                                                        {" "}

                                                        {
                                                            item.academicSession
                                                        }

                                                    </p>

                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                )
                            )
                        }

                    </div>

                </div>

            </div>

            {/* FOOTER */}
            <Footer />

        </>
    );
};

export default AlumniComment;